/* GLADIATOR HOOPS - Bundle & Save (ghbs)
   Replaces the paid bundle app. Discount engine is the BUNDLE10 code
   (10% off the 4 wall-mount hoops + Custom Print Wall Pads, min qty 2).
   This file only decides WHEN to apply it and renders the storefront UI.

   IMPORTANT: the pad is a made-to-order printed product whose cart line carries
   Design File / House Design / Background Color / Placement properties. It must
   NEVER be added from here - the pad side is always a link to its designer page.
   Only the hoop side gets an add-to-cart button. */
(function () {
  'use strict';

  function money(cents, fmt) {
    var amount = (Math.round(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function readJSON(el) {
    if (!el) { return null; }
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function applyAndGo(code) {
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
  }

  function addLines(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (r.ok) { return r.json(); }
      return r.json().then(function (d) {
        throw new Error(d.description || d.message || 'Could not add to cart.');
      });
    });
  }

  function optionData(select) {
    if (!select) { return null; }
    var opt = select.options[select.selectedIndex];
    if (!opt || !opt.value) { return null; }
    return {
      id: parseInt(opt.value, 10),
      price: parseInt(opt.getAttribute('data-price'), 10) || 0,
      image: opt.getAttribute('data-image') || ''
    };
  }

  /* Partner is either a picker (hoop side, addable) or a fixed product (pad side, link only). */
  function partnerData(root, cfg) {
    var select = root.querySelector('[data-ghbs-partner]');
    if (select) { return optionData(select); }
    if (cfg && cfg.partnerPrice) {
      return { id: cfg.partnerId || 0, price: parseInt(cfg.partnerPrice, 10) || 0, image: '' };
    }
    return null;
  }

  /* ---------- product page module ---------- */
  function initProduct(root) {
    var cfg = readJSON(root.querySelector('[data-ghbs-json]'));
    if (!cfg) { return; }

    var select = root.querySelector('[data-ghbs-partner]');
    var saveEl = root.querySelector('[data-ghbs-save]');
    var totalEl = root.querySelector('[data-ghbs-total]');
    var wasEl = root.querySelector('[data-ghbs-was]');
    var thumb = root.querySelector('[data-ghbs-thumb]');
    var btn = root.querySelector('[data-ghbs-add]');
    var errEl = root.querySelector('[data-ghbs-error]');

    var form = document.querySelector('[data-product-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;

    var selfMap = {};
    (cfg.self || []).forEach(function (v) { selfMap[String(v.id)] = v; });

    function selfVariant() {
      var id = (idInput && idInput.value) ? String(idInput.value) : String(cfg.selfDefault);
      return selfMap[id] || selfMap[String(cfg.selfDefault)] || null;
    }

    function qty() {
      var n = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      return (n && n > 0) ? n : 1;
    }

    function render() {
      var s = selfVariant();
      var p = partnerData(root, cfg);
      if (!s || !p) { return; }
      var was = (s.price * qty()) + p.price;
      var save = Math.round(was * cfg.percent / 100);
      if (saveEl) { saveEl.textContent = money(save, cfg.moneyFormat); }
      if (totalEl) { totalEl.textContent = money(was - save, cfg.moneyFormat); }
      if (wasEl) { wasEl.textContent = money(was, cfg.moneyFormat); }
      if (thumb && p.image) { thumb.src = p.image; thumb.hidden = false; }
    }

    if (select) { select.addEventListener('change', render); }
    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target && e.target.closest('[data-option-select], input[name="quantity"]')) {
          window.setTimeout(render, 0);
        }
      });
      form.addEventListener('click', function (e) {
        if (e.target && e.target.closest('[data-qty-step]')) { window.setTimeout(render, 0); }
      });
    }

    if (btn && select) {
      btn.addEventListener('click', function () {
        var s = selfVariant();
        var p = optionData(select);
        if (!s || !p) { return; }
        var label = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding...';
        if (errEl) { errEl.hidden = true; }
        addLines([{ id: p.id, quantity: 1 }])
          .then(function () { applyAndGo(cfg.code); })
          .catch(function (err) {
            btn.disabled = false;
            btn.textContent = label;
            if (errEl) { errEl.textContent = err.message; errEl.hidden = false; }
          });
      });
    }

    render();
  }

  /* ---------- cart page bar ---------- */
  function initCart(root) {
    var code = root.getAttribute('data-ghbs-code') || 'BUNDLE10';
    var eligible = root.getAttribute('data-ghbs-eligible') === '1';
    var applied = root.getAttribute('data-ghbs-applied') === '1';
    var KEY = 'ghbs_try';

    if (applied || !eligible) {
      try { window.sessionStorage.removeItem(KEY); } catch (e) { }
    }

    if (eligible && !applied) {
      var tries = 0;
      try { tries = parseInt(window.sessionStorage.getItem(KEY) || '0', 10) || 0; } catch (e2) { tries = 0; }
      if (tries < 2) {
        try { window.sessionStorage.setItem(KEY, String(tries + 1)); } catch (e3) { }
        window.location.replace('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart'));
        return;
      }
    }

    var select = root.querySelector('[data-ghbs-partner]');
    var btn = root.querySelector('[data-ghbs-add]');
    var errEl = root.querySelector('[data-ghbs-error]');
    if (!btn || !select) { return; }

    btn.addEventListener('click', function () {
      var p = optionData(select);
      if (!p) { return; }
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding...';
      if (errEl) { errEl.hidden = true; }
      addLines([{ id: p.id, quantity: 1 }])
        .then(function () { applyAndGo(code); })
        .catch(function (err) {
          btn.disabled = false;
          btn.textContent = label;
          if (errEl) { errEl.textContent = err.message; errEl.hidden = false; }
        });
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ghbs="product"]'), initProduct);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ghbs="cart"]'), initCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();